import { render, staticRenderFns } from "./ConsultPages.vue?vue&type=template&id=9d8d9fc0&"
import script from "./ConsultPages.vue?vue&type=script&lang=js&"
export * from "./ConsultPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports